import React from 'react';
import classNames from 'classnames';
import './styles.scss';

const CoursesTitle = ({ topTitle, mainTitle, isAvailableCourses, centered }) => {
  if (!mainTitle) return null;
  if (isAvailableCourses) {
    return (
      <div className="available-courses-title">
        <h2>{mainTitle}</h2>
      </div>
    );
  }
  return (
    <div className={classNames('courses-carousel__title', centered && 'courses-carousel__title_centered')}>
      {topTitle && <p>{topTitle}</p>}
      <h2>{mainTitle}</h2>
    </div>
  );
};

export default CoursesTitle;
